import axios from "axios"
import { API_BASE_URL } from "../config"

export const authResetPassword = async (mail: string, type: number) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/reset_password`, {
        user_id: mail,
        type: type
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
